import React, { useEffect, useState } from "react";
import Header from "../layout/header";
import "./profile.css";
import BottomMenu from "../layout/bottomMenu";
import DashboardMenu from "../layout/dashboardMenu";
import logo from '../../Images/park_logo.png'
import callWebService, {callTypes} from "../../service/Networks/network";
import Config from "../../service/Config/config";


const Profile =  ({history = null}) => {
    const [user, setUser] = useState([]);
    const [role, setRole] = useState([]);
     
    useEffect(() => {
        (async () => {
            // token = localStorage.getItem("token");
            let userProfile = localStorage.getItem('user_profile')

            if (userProfile !== null) {
                let userDetails = JSON.parse(userProfile)
                setUser(userDetails)
                setRole(userDetails?.roles[0]);
                return
            }

            var config = { headers: { "Content-Type": "application/json","Authorization":localStorage.getItem("token")} };
            const base_url = process.env.REACT_APP_API_URL;
            const role_id = localStorage.getItem("role_id");
            let {data} = await callWebService(callTypes.get, '',`${Config?.getProfile}?source=leadx&roleId=${role_id}`);
            // const {data}  = await axios.get(
            //     base_url + `/api/v1/getProfile?roleId=${role_id}&source=leadx`,
            //     config
            // );
            let webView = window.localStorage.webview
            if(parseInt(data.response.status_code) === 401 || parseInt(data.response.status_code) === 500){
                delete localStorage.clear()
                window.location.href="/"
                if(webView !== undefined && webView == 'true'){
                    console.log("logout event fired")
                    const message = {
                        event_name: 'logout_user',
                        page:"header.js profile"
                    }
                    const nativeObject = window.ReactNativeWebView;
                    if (nativeObject !== undefined) {
                        nativeObject.postMessage(JSON.stringify(message));
                        window.addEventListener('message', () => {})
                    }
                }
            }

            if(data.response.data)
            {
                //console.log('data - ' + data.response.data?.email);
                // localStorage.setItem("role_id", JSON.stringify(data?.response?.data?.roles[0]?.pivot?.role_id));
                setUser(data.response.data);
                if(data.response.data?.roles !== undefined && data.response.data?.roles[0] !==undefined){
                    setRole(data.response.data?.roles[0]);
                }
            }
        })()
    },[]);
    //console.log(user?.current_image);

    useEffect(() => {
        console.log('dashboard');
    },[]);
    return( 
        <>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <div id="wrapper">   
            <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            history={history}
                        />


                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">  
                            <div className="col-sm-12">
                            {/* <div class="container d-flex justify-content-center"> */}
                                <div className="profile-card p-3 py-4">
                                    <div className="text-center">
                                        {/*rounded-circle*/}
                                    <img src={logo} width="100" className="logo"  alt={""}/>
                                        <h3 className="mt-2">{user?.name}</h3>
                                        <span className="mt-1 clearfix lh2">({role?.title})</span>
                                        <span className="mt-1 clearfix lh2"><i className="bi bi-telephone"></i> {user?.mobile_number}</span>
                                        <span className="mt-1 clearfix lh2"><i className="bi bi-envelope"></i> {user?.email}</span>
                                        <hr className="line mt-2" />
                                        {/* <div class="mt-3 mb-3 desktop-d-flex">
                                        
                                        <div class="col-md-4">
                                            <h5>Total Accounts</h5>
                                            <span class="num">10</span>
                                        </div>
                                        <div class="col-md-4">
                                        <h5>Team Member</h5>
                                            <span class="num">17</span>
                                        </div>
                                        <div class="col-md-4">
                                        <h5>Won Opportunity</h5>
                                            <span class="num">8</span>
                                        </div>
                                        
                                        </div>
                                        
                                        <hr class="line" /> */}
                                        
                                        <small className="mt-4">I am {role?.title} working at park+</small>
                                        <div className="social-buttons mt-5">
                                        <img className="w250" src={`img/${user?.current_image}`} style={{maxWidth: '100%'}}  alt={""}/>
                                        </div>
                                        
                                        <div className="profile mt-5 hide">
                                        <button className="profile_button px-5">Edit profile</button>
                                        </div>
                                        
                                    </div>
                                </div>
                            {/* </div> */}
                            </div>
                          </div>  
                         </div> 
                        {/*END BODY*/}
                    </div>

                </div>
                <BottomMenu/>
            </div>
            {/* section ends */}
        </>
    )
}

export default Profile